import {momentRange} from "../../../../../gd/convert/moment-range";
import formatDaterange from "../../../../../gd/format/daterange";


export default class ReportDaily_Settings {

    // View settings
    public daterange    : DateRange
    public users        : ID[]
    public clockedInHour: boolean
    public requiredHours: boolean
    public workdays     : boolean
    public offDays      : boolean

    constructor(data: any) {
        this.daterange  = data?.daterange ? momentRange(data.daterange.start, data.daterange.end) : momentRange(moment().subtract(1, "month"), moment())
        this.users      = _.get(data, "users", [])
        this.clockedInHour = _.get(data, "clockedInHour", true)
        this.requiredHours = _.get(data, "requiredHours", true)
        this.workdays      = _.get(data, "workdays", false)
        this.offDays       = _.get(data, "offDays", false)
    }

    get reportTitle() {
        let title = ""

        title += formatDaterange(this.daterange)

        return title
    }

    toJSON(): JSONObject {
        const result : JSONObject =  {
            users           : this.users,
            clockedInHour   : this.clockedInHour,
            requiredHours   : this.requiredHours,
            workdays        : this.workdays,
            offDays         : this.offDays,
        }

        if (this.daterange) {
            result['daterange'] = {
                start   : this.daterange.start.format("YYYY-MM-DD"),
                end     : this.daterange.end.format("YYYY-MM-DD")
            }
        }

        return result
    }
}
